module.exports = __webpack_public_path__ + "static/media/eusoupepsico.f6ea9096.svg";